import apiClient from '@/api/client';
import type {
  IndustrialRefBookListResponse,
  IndustrialRefBookRecord,
  IndustrialRefBookSuggestionListResponse,
} from '@/types/industrialRefBook';

export interface ListIndustrialRefBookParams {
  readonly limit: number;
  readonly offset: number;
  readonly search?: string;
  readonly signal?: AbortSignal;
}

export async function listIndustrialRefBook(
  params: ListIndustrialRefBookParams,
): Promise<IndustrialRefBookListResponse> {
  const response = await apiClient.get<IndustrialRefBookListResponse>(
    '/api/v1/industrial-ref-book',
    {
      params: {
        limit: params.limit,
        offset: params.offset,
        search: params.search && params.search.length > 0 ? params.search : undefined,
      },
      signal: params.signal,
    },
  );
  return response.data;
}

export async function suggestIndustrialRefBook(
  q: string,
  limit = 10,
  signal?: AbortSignal,
): Promise<IndustrialRefBookSuggestionListResponse> {
  const response = await apiClient.get<IndustrialRefBookSuggestionListResponse>(
    '/api/v1/industrial-ref-book/suggest',
    { params: { q, limit }, signal },
  );
  return response.data;
}

export async function fetchIndustrialRefBookItem(
  id: number,
): Promise<IndustrialRefBookRecord> {
  const response = await apiClient.get<IndustrialRefBookRecord>(
    `/api/v1/industrial-ref-book/${id}`,
  );
  return response.data;
}
